import {
  NORMALMAPSTYLES,
  getFilePath,
  isFileExists,
  INVALID_1000,
  isDefined,
  FILES
} from "../shared/index";
import ColorMapHelper from "../js/ColorMapHelper";
import fileSys from "../../fileoprators/fileSystem";
import { calcElevDiff } from "../js/calc4mmElevDiff";
import CalCaseDebug from "../js/CalCaseDebug";
const addonDT = window.__ct__.debug
  ? CalCaseDebug
  : window.require(fileSys.getUtilPath("DEA520Data.node"));
function initArrWithInvalidVal(px, py, pz) {
  px.fill(INVALID_1000);
  py.fill(INVALID_1000);
  pz.fill(INVALID_1000);
}
export const normalMapValues = (dataparams, eyetype, medianMode, mm) => {
  let _mapValues = {};
  dataparams.getBaseParams();
  _mapValues.params = dataparams.params;
  _mapValues.eyetype = eyetype;
  dataparams.getMajMedian(medianMode);
  _mapValues.frontpValOfMajMeridians = dataparams.frontpValOfMajMeridians;
  _mapValues.isShowGrayF = dataparams.isShowGrayF;
  _mapValues.majMedian = dataparams.majMedian;
  dataparams.getSagCurMedian();
  _mapValues.sagCurMedian = dataparams.sagcurMedian;
  _mapValues.params.EccPEQ.value = dataparams.getOneMajMedian(mm);
  if (fileSys.isFileExists(dataparams.casePath)) {
    let objDiff = calcElevDiff(
      dataparams.casePath,
      _mapValues.params.AxisFlat.value,
      _mapValues.params.AxisSteep.value
    );
    _mapValues.params.elevDiff4mm.value = objDiff.val;
    _mapValues.params.elevDiff4mm.analog = objDiff.analog;
  }
  return _mapValues;
};
export const mapReference = {
  getPixelIndexAndValue: (ptr, x, y) => {
    return ColorMapHelper.getPixelIndexAndValue(ptr, x, y);
  },
  getNumVals: (ptr) => {
    const kLen = 81;
    let px = new Float64Array(kLen);
    let py = new Float64Array(kLen);
    let pz = new Float64Array(kLen);
    initArrWithInvalidVal(px, py, pz);
    if (isDefined(ptr) && ptr > 0) {
      ColorMapHelper.getNumVals(ptr, kLen, px, py, pz);
      return {
        px: px,
        py: py,
        pz: pz
      };
    } else {
      return null;
    }
  },
  readMinMaxVals: (casepath, mapStyle, isD) => {
    const kLen = 20;
    let px = new Float64Array(kLen);
    let py = new Float64Array(kLen);
    let pz = new Float64Array(kLen);
    initArrWithInvalidVal(px, py, pz);
    let filename = "nothing";

    switch (mapStyle) {
      case NORMALMAPSTYLES[0]:
        filename = FILES.tanF;
        break;
      case NORMALMAPSTYLES[1]:
        filename = FILES.sagF;
        break;
      default:
        break;
    }
    let filepath = getFilePath(casepath, filename);
    if (isFileExists(filepath)) {
      addonDT.ReadMinMaxVals(filepath, isD, px.buffer, py.buffer, pz.buffer, kLen);
      return {
        px: px,
        py: py,
        pz: pz
      };
    } else {
      return null;
    }
  },
  readPupilPara: (casepath) => {
    const kLen = 360;
    let pupilX = new Float64Array(kLen);
    let pupilY = new Float64Array(kLen);
    pupilX.fill(INVALID_1000);
    pupilY.fill(INVALID_1000);
    let filepath = getFilePath(casepath, FILES.pupilEdge);
    if (isFileExists(filepath)) {
      addonDT.ReadPupilPara(filepath, pupilX.buffer, pupilY.buffer, kLen);
      return {
        px: pupilX,
        py: pupilY
      };
    } else {
      return null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/topography/dataGetters/mapValues.js